import React from "react";
import { Form, Button, Label } from "semantic-ui-react";
import { Field, reduxForm } from "redux-form";
import TextInput from "../../../app/common/form/TextInput";
import { connect } from "react-redux";
import {
  combineValidators,
  isRequired,
  composeValidators,
  hasLengthGreaterThan,
} from "revalidate";
import { loginUser } from "../authActions";
import { Redirect } from "react-router-dom";
import "./login.css";

const validate = combineValidators({
  username: isRequired({ message: "Username is required" }),
  password: composeValidators(
    isRequired({ message: "Password is required" }),
    hasLengthGreaterThan(5)({
      message: "Password needs to be atleast 6 characters",
    })
  )(),
});

export const LoginForm = ({
  handleSubmit,
  loginUser,
  error,
  invalid,
  submitting,
  isAuthenticated,
}) => {
  if (isAuthenticated) return <Redirect to="/" />;

  return (
    <div className="login-page">
      <div className="login-page__glow login-page__glow--orange" aria-hidden="true" />
      <div className="login-page__glow login-page__glow--purple" aria-hidden="true" />

      <div className="login-page__shell">
        <header className="login-page__brand">
          <img
            src="/assets/suprol-logo.png?v=2"
            alt="SUPROL — World Class Spectacle Lenses"
            className="login-page__logo"
          />
        </header>

        <div className="login-page__card">
          <div className="login-page__card-header">
            <p className="login-page__eyebrow">OMS Access</p>
            <h1 className="login-page__title">Welcome back</h1>
            <p className="login-page__subtitle">
              Sign in with your credentials to continue.
            </p>
          </div>

          <Form
            error
            className="login-page__form"
            onSubmit={handleSubmit(loginUser)}
          >
            <label className="login-page__label">
              Username
            </label>
            <Field
              name="username"
              component={TextInput}
              type="text"
              placeholder="Enter username"
              autoFocus
            />

            <label className="login-page__label">
              Password
            </label>
            <Field
              name="password"
              component={TextInput}
              type="password"
              placeholder="Enter password"
            />

            {error && (
              <Label basic color="red" className="login-page__error">
                {error}
              </Label>
            )}

            <Button
              fluid
              type="submit"
              className="login-page__submit"
              disabled={invalid || submitting}
              loading={submitting}
            >
              Sign in
            </Button>
          </Form>
        </div>

        <p className="login-page__footer">World Class Spectacle Lenses</p>
      </div>
    </div>
  );
};

const actions = {
  loginUser,
};
const mapStateToProps = (state) => ({
  isAuthenticated: state.auth.authenticated,
});

export default connect(
  mapStateToProps,
  actions
)(reduxForm({ form: "loginForm", validate })(LoginForm));
